import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'rmwc/Slider';

export const getSliderState = (value, spec) => {
  return value === null ? spec._default : value;
};

const setMarkerValue = (persistentPin, api, value) => {
  if (persistentPin) {
    api.foundation_.adapter_.setMarkerValue(value);
  }
};

export const SliderControl = ({ value, spec, persistentPin, className, ...other }) => {
  const { min, max, step_size, _default } = spec;

  if (value === null) {
    console.warn('Slider passed value of null. Use getSliderState to retrieve a default state from _spec.');
    value = value === null ? _default : value;
  }

  if (persistentPin) {
    className = className ? className + ' hrbr-persistent-pin' : 'hrbr-persistent-pin';
  }
  return (
    <Slider
      apiRef={selectApi => setMarkerValue(persistentPin, selectApi, value)}
      value={value}
      min={min}
      max={max}
      step={step_size}
      className={className}
      {...other}
    />
  );
};
